import { Card, Filter, InfoBox, Pagination, Table, ViewHeader, useGet } from '@enkla-gui'

import { icons } from '@config'

export default function Overview() {
  const { data: leases, setSorting, setPage, sorting, loading, setFilter } = useGet({ endpoint: `api/lease` })
  const { data: companies } = useGet({ endpoint: 'api/company' })
  const { data: billable } = useGet({ endpoint: 'api/auth/billable' })

  return (
    <>
      <ViewHeader icon='fa-key' title='Uthyrningar' subtitle='Översikt'
        buttons={[{ icon: icons.create, title: 'Skapa uthyrning', href: '#!/lease/create' }]}
      />
      <div class='row'>
        <InfoBox loading={!leases} title='Aktiva Uthyrningar' subtitle={billable?.stat_active_leases} icon='fa-calendar-check' />
        <InfoBox loading={!leases} title='Vakanser' subtitle={billable?.stat_vacancies} icon='fa-calendar-times' />
        <InfoBox loading={!leases} title='Upphörande denna månad' subtitle={billable?.stat_ends_month} icon='fa-clock' />
      </div>
      <Filter
        filters={[
          {
            type: 'select',
            label: 'Status',
            key: 'state',
            values: [
              {
                label: 'Pågående',
                value: 'active'
              },
              {
                label: 'Kommande',
                value: 'planned'
              },
              {
                label: 'Upphörande',
                value: 'ending'
              },
            ]
          },
          {
            type: 'select',
            label: 'Företag',
            key: 'company',
            values: (companies?.data || []).map(c => ({ label: c.name, value: c.id }))
          }
        ]}
        useFilter={_filter => setFilter({ ..._filter })}
      />
      <Card>
        <Table
          loadercount={15}
          sorting={sorting}
          fetching={loading}
          useSorting={sort => setSorting({ ...sort })}
          rows={leases?.data}
          empty={{
            text: 'Det finns inte några uthyrningar',
            icon: 'fa-key'
          }}
          link={`/#!/lease/@{id}`}
          functions={{
            active: lease => <span class={`badge bg-${lease.state.color} w-100`}>{lease.state.title}</span>,
            getType: type => (
              <div class='icon-badge'>
                <i class={`fas fa-fw ${type.icon}`} /> <span>{type.name}</span>{' '}
              </div>
            ),
            entity: entity => (
              <a class='text-decoration-none' onClick={e => e.stopPropagation()} href={`/#!/entity/${entity.id}/`}>
                {entity.name}
              </a>
            ),
            company: lease => {
              return (<a class='text-decoration-none' onClick={e => e.stopPropagation()} href={`/#!/company/${lease?.company?.id}/`}>
                {lease?.company?.name}
              </a>)
            }
          }}
          keys={['_this>function:active', 'entity>function:entity', '_this>function:company', 'entity.type>function:getType', 'primary_tenant.name', 'start>date:short', 'stop>date:short']}
          headers={[
            {
              value: 'Status',
              class: 'min'
            },
            {
              value: 'Objekt',
              class: 'min'
            },
            {
              value: 'Företag',
              class: 'min'
            },
            {
              value: 'Typ',
              class: 'min'
            },
            {
              value: 'Primär Hyresgäst'
            },
            {
              key: 'start',
              value: 'Tillträde',
              sortable: true,
              class: 'min'
            },
            {
              key: 'stop',
              value: 'Slutdatum',
              sortable: true,
              class: 'min'
            }
          ]}
        />
        <Pagination data={leases} fetch={setPage} pushToHistory />
      </Card>
    </>
  )
}
